import React, { useEffect, useState } from 'react';
import AdminLayout from './components/adminlayout';
import { serverURL } from '../constants';
import axios from 'axios';
import CourseTable from './components/coursetable';

const Courses = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        sessionStorage.setItem('darkMode', false);
        async function fetchData() {
            const response = await axios.get(serverURL + `/api/getcourses`);
            setData(response.data);
        }
        fetchData();
    }, []);

    return (
        <AdminLayout>
            <div className='p-6'>
                <CourseTable datas={data} />
            </div>
        </AdminLayout>
    );
};
export default Courses;
